import { getQuery } from '@/features/AudienceManager/services';
export const fetchQuery = (audienceId) => {
    return getQuery(audienceId).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    return {
        success: response?.success,
        errors: response?.errors,
        data: {
            id: response?.data.id,
            name: response?.data.name,
            query: response?.data.query,
        },
    };
};
